(() => {
  const origin='https://optisofa-planner-production.up.railway.app';
  const root=document.documentElement;
  const getFrame=()=>document.querySelector('.optisofa-planner-overlay shopify-overlay-planner-helper iframe');
  const active=()=>{try{return new URL(getFrame().src).origin===origin}catch{return false}};
  let api = null, initializing = false, mounted = false, unread = 0, requested = false, childReady = false;
  const send = (type, detail = {}) => { if (active() && childReady) getFrame().contentWindow?.postMessage({ type, ...detail }, origin); };
  const state = () => send('planner:chat:state', { ready: !!api, unread });
  const reset = () => {
    mounted = false; requested = false;
    root.classList.remove('planner-chat-custom');
    state();
  };
  const style = document.createElement('style');
  style.textContent = `
    html.planner-chat-custom #gorgias-chat-container iframe#chat-button,
    html.planner-chat-custom #gorgias-chat-container iframe#chat-campaigns{display:none!important}
    html.planner-chat-custom #gorgias-chat-container{position:relative;z-index:2147483647!important}
    html.planner-chat-custom #gorgias-chat-container iframe#chat-window{z-index:2147483647!important}
  `;
  document.head.append(style);

  async function connect() {
    if (api || initializing || !window.GorgiasChat || !active()) return;
    initializing = true;
    try {
      const chat = window.GorgiasChat;
      await chat.init();
      if (typeof chat.open !== 'function' || typeof chat.on !== 'function') return;
      api = chat;
      chat.on('unreadCount', count => { unread = Number.isInteger(count) ? Math.max(0, count) : 0; state(); });
      chat.on('widget:opened', () => {
        if (!mounted || !active()) return;
        if (!requested) { chat.close(); return; }
        send('planner:chat:opened');
      });
      chat.on('widget:closed', () => {
        if (requested) { requested = false; send('planner:chat:closed'); }
      });
      chat.on('destroy', () => { api = null; reset(); });
      state();
    } catch { api = null; state(); }
    finally { initializing = false; }
  }

  window.addEventListener('message', event => {
    if (!active() || event.source !== getFrame().contentWindow || event.origin !== origin) return;
    switch (event.data?.type) {
      case 'planner:chat:hello': childReady = true; state(); connect(); break;
      case 'planner:chat:mounted':
        if (api) {
          mounted = true; root.classList.add('planner-chat-custom');
          if (!requested && api.isOpen?.()) api.close();
        }
        break;
      case 'planner:chat:open':
        if (!api || !mounted) { send('planner:chat:unavailable'); return; }
        requested = true;
        try { api.open(); if (api.isOpen?.()) send('planner:chat:opened'); }
        catch { api = null; reset(); send('planner:chat:unavailable'); }
        break;
    }
  });
  window.addEventListener('gorgias-widget-loaded', connect);
  window.addEventListener('pageshow', () => { state(); connect(); });
  connect();
  let attempts = 0;
  const timer = setInterval(() => {
    connect();
    if (api || ++attempts >= 60 || !frame.isConnected) clearInterval(timer);
  }, 500);
})();
